module.exports = __webpack_public_path__ + "static/cate-Fun-525eff9e0fc230084ac991fe317a2683.jpg";